import { axiosCore } from './http-core-service';
import { ResultSearchDto } from './dtos/result-search.dto';
import {
    InterventionDto,
    ProposalAssignmentDto,
    SearchInterventionsDto,
    SearchProposalAssignmentsDto,
} from './dtos/assignments.dto';

/**
 * Méthode qui récupère les propositions d'affectations
 * @return des interventions
 */
export const serviceSearchProposalsAssignments = async (
    data: SearchProposalAssignmentsDto
): Promise<ResultSearchDto<ProposalAssignmentDto>> => {
    // Récupération
    const criterions: string = getCriterionsProposalAssignments(data);

    // Création d'un json pour la requête
    const response = await axiosCore.get(
        `/api/assignments-proposals/mandates/${data.mandateId}/search?page=${data.page + 1}&itemsPerPage=${
            data.itemsPerPage
        }${criterions}`
    );

    return response.data;
};

/**
 * Méthode qui récupère les propositions d'affectations
 * @return des interventions
 */
export const sendConfirmationProposalAssignment = async (
    proposalAssignments: ProposalAssignmentDto,
    mandateId: string,
    validation: boolean,
    motifRefus?: string
): Promise<unknown> => {
    // Création de la data
    const data = {
        sortieId: proposalAssignments.sortieId,
        reference: proposalAssignments.reference,
        validation: validation,
        motifRefus: motifRefus,
    };
    // Création d'un json pour la requête
    const response = await axiosCore.post(`/api/assignments-proposals/mandates/${mandateId}/confirmation`, data);

    return response.data;
};

/**
 * Méthode qui récupère les interventions
 * @return des interventions
 */
export const serviceSearchInterventions = async (
    data: SearchInterventionsDto
): Promise<ResultSearchDto<InterventionDto>> => {
    // Récupération
    const criterions: string = getCriterionsInterventions(data);

    // Création d'un json pour la requête
    const response = await axiosCore.get(
        `/api/assignments-proposals/interventions/mandates/${data.mandateId}/search?page=${
            data.page + 1
        }&itemsPerPage=${data.itemsPerPage}${criterions}`
    );

    return response.data;
};

/**
 * Méthode qui récupère les critères dans un string
 * @return string
 */
export const getCriterionsProposalAssignments = (data: SearchProposalAssignmentsDto): string => {
    let criterions = '';
    //si recherche par référence
    if (data.paramReference) {
        criterions += `&reference=${data.paramReference}`;
    }
    //si recherche par Code TBB
    if (data.paramcodeTBB) {
        criterions += `&codeTBB=${data.paramcodeTBB}`;
    }
    //si recherche par nom
    if (data.paramName) {
        criterions += `&name=${data.paramName}`;
    }
    //si recherche par lieu
    if (data.paramPlace) {
        criterions += `&place=${data.paramPlace}`;
    }
    //Tri
    if (data.sort) {
        criterions += `&sort=${data.sort}`;
    }
    //Ordre du tri
    if (data.sort && data.order) {
        criterions += `&order=${data.order}`;
    }

    return criterions;
};

/**
 * Méthode qui récupère les critères dans un string
 * @return string
 */
export const getCriterionsInterventions = (data: SearchInterventionsDto): string => {
    let criterions = '';
    //si recherche par référence
    if (data.paramReference) {
        criterions += `&reference=${data.paramReference}`;
    }
    //si recherche par Code TBB
    if (data.paramcodeTBB) {
        criterions += `&codeTBB=${data.paramcodeTBB}`;
    }
    //si recherche par nom
    if (data.paramName) {
        criterions += `&name=${data.paramName}`;
    }
    //si recherche par lieu
    if (data.paramPlace) {
        criterions += `&place=${data.paramPlace}`;
    }
    //si recherche par Code TBB
    if (data.paramPlannedDate) {
        criterions += `&plannedDate=${data.paramPlannedDate}`;
    }
    //si recherche par nom
    if (data.paramRealisationDate) {
        criterions += `&realisationDate=${data.paramRealisationDate}`;
    }
    //si recherche par lieu
    if (data.paramState) {
        criterions += `&state=${data.paramState}`;
    }
    //Tri
    if (data.sort) {
        criterions += `&sort=${data.sort}`;
    }
    //Ordre du tri
    if (data.sort && data.order) {
        criterions += `&order=${data.order}`;
    }

    return criterions;
};
